var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup134(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(-581 -2658)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 76,
    height: 75,
    rx: 10,
    transform: "translate(581 2658)",
    fill: "#eff3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "window-alt",
    d: "M48.468,15.136V11.1A10.1,10.1,0,0,0,38.37,1H10.1A10.1,10.1,0,0,0,0,11.1v4.039ZM39.38,5.039a3.029,3.029,0,1,1-3.029,3.029A3.025,3.025,0,0,1,39.38,5.039Zm-8.078,0a3.029,3.029,0,1,1-3.029,3.029A3.025,3.025,0,0,1,31.3,5.039Zm-8.078,0a3.029,3.029,0,1,1-3.029,3.029A3.025,3.025,0,0,1,23.224,5.039ZM48.468,19.175V35.331a10.1,10.1,0,0,1-10.1,10.1H10.1A10.1,10.1,0,0,1,0,35.331V19.175Z",
    transform: "translate(595 2672.286)",
    fill: "#99aff1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup134);
export default __webpack_public_path__ + "static/media/Group 134.d8df13fd8cfcdc02534765edf635f4fb.svg";
export { ForwardRef as ReactComponent };